'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.activateTab = exports.cacheProductData = exports.getAllProductData = exports.closeProductOptions = exports.productData = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _Helpers = require('scripts/components/Helpers');

var _Modal = require('scripts/components/Modal');

var _Scroll = require('scripts/components/Scroll');

var _Klaviyo = require('scripts/components/Klaviyo');

var _Accordion = require('scripts/components/Accordion');

var _OOSAddToCart = require('scripts/components/OOSAddToCart');

var _PropValues = require('scripts/components/PropValues');

var _ProductReviews = require('scripts/components/ProductReviews');

var _CrossSellCollection = require('scripts/components/CrossSellCollection');

var _LazyLoader = require('scripts/components/LazyLoader');

var _Venobox = require('scripts/components/Venobox');

var _Cart = require('scripts/modules/Cart');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breakpoint = 992;
// Modules
// Components

var product = void 0;
var variantData = void 0;
var productData = exports.productData = void 0;
var productDataCached = false;

var GALLARY_SLICK_CONFIG = {
  rows: 0,
  fade: true,
  dots: false,
  infinite: false,
  arrows: false,
  slidesToShow: 1,
  centerMode: true
};
var THUMBNAIL_ACTIVE_CLASS = 'thumbnails__container--active';

var dom = {
  productGallery: '[data-gallery-gallery]',
  productGallerySlide: '[data-gallery-main-product-id]',
  productGalleryThumbnail: '[data-gallery-thumbnail-product-id]',
  option: '[product-option]',
  descriptionHeader: '[product-description-header]',
  descriptionContent: '[product-description-content]',
  price: '[product-price]',
  subscriptionPrice: '[product-subscription-price]',
  addToCart: '[pdp-atc]',
  qty: '[product-qty]',
  qtyAdjustBtn: '[product-qty-adjust]',
  navTab: '[product-details-nav-tab]',
  navTarget: '[product-details-nav-target]',
  navRow: '[product-details-nav-row]',
  optionSelectTrigger: '[product-select-trigger]',
  optionSelectModal: '[data-modal="option-select"]',
  optionSelectModalClose: '[data-modal="option-select"] [data-modal-hide]',
  selectSwatchThumbnail: '[product-selected-swatch]',
  selectSwatchTitle: '[product-selected-title]',
  subscriptionOptions: '[product-subscription-options]',
  subscriptionOption: '[subscription-option]',
  subscriptionOptionLabel: '[subscription-option-label]',
  subscriptionFreqOption: '[subscription-freq-option]',
  subscriptionFreqSelect: '[subscription-freq-select]',
  form: '[product-form]',
  purchseTypeInput: '[name="purchase_type"]',
  packItemInput: '[pack-item-input]',
  reviewsAnchor: '[reviews-anchor]',

  upgradeProductViaUpsell: '[remove-old-product-via-pack-upsell]',

  descHeadline: '[desc-headline]',
  descSubHeadline: '[desc-sub-headline]',
  descSidebarLeft: '[sidebar-left-content]',
  descSidebarRight: '[sidebar-right-content]',
  descImage: '[desc-image]',
  descProps: '[value-prop]',

  shopifyProductForm: '[shopify-product-form]',
  shopifyOptionSelector: '.single-option-selector',
  swatch: '[swatch]'
};

var onGalleryChange = function onGalleryChange(_, __, ___, nextSlideIndex) {
  var $thumbnails = $(dom.productGalleryThumbnail);
  var $slides = $(dom.productGallerySlide);
  var nextSlide = $slides[nextSlideIndex];
  var _nextSlide$dataset = nextSlide.dataset,
      galleryMainProductId = _nextSlide$dataset.galleryMainProductId,
      galleryMainImageId = _nextSlide$dataset.galleryMainImageId;


  $thumbnails.removeClass(THUMBNAIL_ACTIVE_CLASS).filter('[data-gallery-thumbnail-product-id="' + galleryMainProductId + '"][data-gallery-thumbnail-image-id="' + galleryMainImageId + '"]').addClass(THUMBNAIL_ACTIVE_CLASS);
};

var onThumbnailClick = function onThumbnailClick(_ref) {
  var currentTarget = _ref.currentTarget;
  var galleryThumbnailProductId = currentTarget.dataset.galleryThumbnailProductId;

  var $thumbnailsMatchingProductId = $('[data-gallery-thumbnail-product-id="' + galleryThumbnailProductId + '"]');
  var index = $thumbnailsMatchingProductId.index(currentTarget);

  if (index > -1) $(dom.productGallery).slick('slickGoTo', index);
};

var initProductGallery = function initProductGallery() {
  (0, _LazyLoader.loadAll)();
  var firstProductId = $(dom.productGallerySlide).first().data('galleryMainProductId');
  $(dom.productGallery).slick(GALLARY_SLICK_CONFIG).on('beforeChange', onGalleryChange);
  if (firstProductId) updateGallery({ id: firstProductId });
};

var updateSelectToggle = function updateSelectToggle(product) {
  $(dom.selectSwatchTitle).text(product.title);
  $(dom.selectSwatchThumbnail).removeAttr('style');
  if (product.swatch_image) {
    $(dom.selectSwatchThumbnail).css('background-image', 'url(' + product.swatch_image + ')');
  } else if (product.swatch) {
    $(dom.selectSwatchThumbnail).css('background-color', '#' + product.swatch);
  }
};

var updateGallery = function updateGallery(product) {
  $('[data-gallery-thumbnail-product-id]').hide().removeClass(THUMBNAIL_ACTIVE_CLASS).filter('[data-gallery-thumbnail-product-id="' + product.id + '"]').show().first().addClass(THUMBNAIL_ACTIVE_CLASS);

  $(dom.productGallery).slick('slickUnfilter').slick('slickFilter', '[data-gallery-main-product-id="' + product.id + '"]').slick('slickGoTo', 0);
};

var updateShortDescription = function updateShortDescription(product) {
  $(dom.descriptionHeader).text(product.title);
  $(dom.descriptionContent).html(product.short_description);
};

var updateDescriptionTab = function updateDescriptionTab(product) {
  if (product.headline) {
    $(dom.descHeadline).text(product.headline);
  }
  if (product.sub_headline) {
    $(dom.descSubHeadline).text(product.sub_headline);
  }
  if (product.ingredients_list_left) {
    $(dom.descSidebarLeft).html(product.ingredients_list_left);
  }
  if (product.ingredients_list_right) {
    $(dom.descSidebarRight).html(product.ingredients_list_right);
  }
  $(dom.descProps).each(function (index) {
    var propKey = 'value_prop_' + (index + 1);
    var prop = product[propKey];
    if (prop) {
      var propTitle = prop.split('</h4>')[0].split('>')[1];
      $(this).html(prop);
      $('[value-prop-title="' + (index + 1) + '"]').text(propTitle);
    }
  });
};

var updateSpecsTab = function updateSpecsTab(product) {
  $(dom.navTarget).filter('[product-details-nav-target="specs"]').html(product.description);
};

var updatePrice = function updatePrice(product, variant) {
  var basePrice = variant.price;
  var discountPrice = false;
  if (product.is_pack) {
    basePrice = variant.compare_at_price;
  }

  if (product.subscriptions_discount) {
    var discountDecimal = product.subscriptions_discount * 0.01;
    var discountPriceAmount = basePrice * discountDecimal;
    discountPrice = Math.round(basePrice - discountPriceAmount);
  }

  $(dom.price).html((0, _Helpers.formatMoney)(basePrice));
  if (discountPrice) {
    $(dom.subscriptionPrice).html((0, _Helpers.formatMoney)(discountPrice));
  }
};

var updateAtc = function updateAtc(variant, product) {
  $(dom.addToCart).attr('add-to-cart', true).removeAttr('add-pack-to-cart').removeAttr('data-variant-ids').removeAttr('pack-title').removeAttr('data-item-count').removeAttr('data-oos-atc').removeAttr('disabled').attr('type', 'submit').text($(dom.addToCart).data('text'));
  var subscriptionVariantId = variant['subscriptions_discount_variant_id'] || variant.id;
  if (product.is_pack) {
    // Use the default variant for pack containers
    subscriptionVariantId = variant.id;
  }
  $(dom.purchseTypeInput).filter('[value="onetime"]').attr('data-variant-id', variant.id);
  $(dom.purchseTypeInput).filter('[value="autodeliver"]').attr('data-variant-id', subscriptionVariantId);
  var activeVariantId = $(dom.purchseTypeInput).filter(':checked').attr('data-variant-id');
  $(dom.addToCart).attr('data-variant-id', activeVariantId);
  if (product) {
    $(dom.addToCart).attr('data-product-title', product.title ? product.title : null);
    $(dom.addToCart).attr('data-upsell-subscription', product.upsell_subscription ? product.upsell_subscription : null);
    $(dom.addToCart).attr('data-upsell-non-subscription', product.upsell_non_subscription ? product.upsell_non_subscription : null);
    $(dom.addToCart).attr('data-upsell-upgrade', product.upsell_is_upgrade);
  }

  $('[data-variant-input]').val(variant.id);

  // console.log(variant);
  // if (!variant.inventory_quantity > 0) {
  if (variant.inventory_quantity < 1) {
    $(dom.addToCart).removeAttr('add-to-cart').attr('type', 'button');

    if (product.vendor === 'Plastic Free' || product.vendor === 'Travel Kit') {
      $(dom.addToCart).attr('data-oos-atc', '');
    } else {
      $(dom.addToCart).attr('disabled', '').text($(dom.addToCart).data('oos-text'));
    }
  }
};

var changeVariantId = function changeVariantId(event) {
  var $this = $(event.currentTarget);
  var variantId = $this.attr('data-variant-id');
  $(dom.addToCart).attr('data-variant-id', variantId);
};

var updateSubscriptionFields = function updateSubscriptionFields(product) {
  if (product.subscriptions_id) {
    var subscriptionId = product.subscriptions_id;
    var subscriptionIntervalFrequencies = product.subscriptions_shipping_interval_frequency;
    var subscriptionIntervalType = product.subscriptions_shipping_interval_unit_type;
    var subscriptionOptionLabel = product.subscriptions_option_label;
    var activeIndex = parseInt($(dom.subscriptionFreqOption).filter('.is-active').attr('data-dropdown-value')) - 1;
    $(dom.subscriptionOption).removeClass('is-hidden');
    $(dom.form).find('[name="properties[subscription_id]"]').val(subscriptionId);
    $(dom.form).find('[name="properties[shipping_interval_unit_type]"]').val(subscriptionIntervalType);
    $(dom.form).find('[subscription-option-label]').text(subscriptionOptionLabel);
    subscriptionIntervalFrequencies.forEach(function (freq, index) {
      var interval = subscriptionIntervalType.replace('s', '');
      var unit = index > 0 ? interval + 's' : interval;
      $(dom.form).find('[subscription-freq="' + index + '"]').text(freq);
      $(dom.form).find('[subscription-unit="' + index + '"]').text(unit);
      if (index == activeIndex) {
        $(dom.form).find('[active-subscription-unit]').text(unit);
      }
    });
  } else {
    $(dom.form).find('[name="purchase_type"][value="onetime"]').prop('checked', true);
    $(dom.form).find('[name="purchase_type"][value="autodeliver"]').attr('disabled', true);
    $(dom.form).find('[name="properties[subscription_id]"]').val('');
    $(dom.form).find('[name="properties[shipping_interval_unit_type]"]').val('');
  }
};

var updatePackProperties = function updatePackProperties(product) {
  if (product.is_pack) {
    var idsArray = product.pack_ids;
    if (idsArray) {
      var ids = idsArray.join(',');
      $(dom.addToCart).removeAttr('add-to-cart');
      $(dom.addToCart).removeAttr('data-variant-id');
      $(dom.addToCart).attr('add-pack-to-cart', true);
      $(dom.addToCart).attr('data-variant-ids', ids);
      $(dom.addToCart).attr('pack-title', product.title);
      $(dom.addToCart).attr('data-item-count', idsArray.length);
    }
    $(dom.price).html((0, _Helpers.formatMoney)(product.variants[0].compare_at_price));
  }
};

var updateUrlHistory = function updateUrlHistory(product) {
  var title = product.title_tag || product.title + ' | Native';
  var url = product.url + window.location.search;
  window.history.replaceState({}, title, url);
  document.title = title;
};

var updateProductMeta = function updateProductMeta(event) {
  (0, _Modal.hide)();
  if (window.innerWidth < 768) $(dom.optionSelectTrigger).trigger('focus');
  var $this = $(event.currentTarget);
  var productId = $this.attr('data-product-id');
  var product = productData[productId] || false;
  $(dom.option).parent().removeClass('is-active');
  $this.parent().addClass('is-active');
  $(dom.subscriptionOption).addClass('is-hidden');
  $(dom.form).find('[name="purchase_type"][value="autodeliver"]').removeAttr('disabled');
  $(dom.packItemInput).remove();

  if (product) {
    window.bva.activeProduct = product;
    window.bva.product.handle = product.handle;
    window.bva.product.data = product;
    var variant = product.variants[0];
    updateGallery(product);
    updateShortDescription(product);
    updateDescriptionTab(product);
    updateSpecsTab(product);
    updateSelectToggle(product);
    updatePrice(product, variant);
    updateAtc(variant, product);
    updateSubscriptionFields(product);
    updatePackProperties(product);
    updateUrlHistory(product);
    (0, _Klaviyo.klaviyoTrackItemView)();
    dataLayer.push({
      event: 'Variant Changed'
    });
  }
};

var closeProductOptions = exports.closeProductOptions = function closeProductOptions() {
  $(dom.optionSelectModal).removeClass('is-active');
};

var getAllProductData = exports.getAllProductData = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var url;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = '//' + window.location.host + window.location.pathname + '?view=json';
            _context.next = 3;
            return fetch(url).then(function (res) {
              return res.json();
            });

          case 3:
            return _context.abrupt('return', _context.sent);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function getAllProductData() {
    return _ref2.apply(this, arguments);
  };
}();

var cacheProductData = exports.cacheProductData = function cacheProductData() {
  getAllProductData().then(function (data) {
    console.log(data);
    exports.productData = productData = data;
    productDataCached = true;
    window.bva.activeProduct = productData[window.bva.product.data.id];
    (0, _Klaviyo.klaviyoTrackItemView)();
  });
};

var qtyBtnHandler = function qtyBtnHandler(event) {
  var $this = $(event.currentTarget);
  var $form = $this.closest(dom.form);
  var updateBy = parseInt($this.attr('product-qty-adjust'));
  var $qty = $form.find(dom.qty);
  var setVal = parseInt($qty.val());
  var maxQty = $qty.attr('data-max') ? parseInt($qty.attr('data-max'), 10) : setVal + updateBy;
  var qty = setVal + updateBy;
  if (qty > maxQty) {
    qty = maxQty;
  }
  if (qty < 1) {
    qty = 1;
  }
  $qty.val(qty).trigger('keyup');
};

var updateQty = function updateQty(event) {
  var $this = $(event.currentTarget);
  var setVal = $this.val();
  var maxQty = $this.attr('data-max') ? parseInt($this.attr('data-max'), 10) : setVal;
  var qty = setVal <= maxQty ? setVal : maxQty;
  var $form = $this.closest(dom.form);
  var $atc = $form.find(dom.addToCart);
  $atc.attr('data-qty', qty);
};

var deactivateTabs = function deactivateTabs() {
  $(dom.navTab).removeClass('is-active');
  $(dom.navRow).removeClass('is-active');
  $(dom.navTarget).removeClass('is-active');
  $(dom.navTarget).filter(':visible').css('display', 'none');
};

var activateTab = exports.activateTab = function activateTab(event, tabName) {
  var navTargetName = tabName || $(event.currentTarget).attr('product-details-nav-tab');
  var $navTab = $(dom.navTab).filter('[product-details-nav-tab="' + navTargetName + '"]');
  var $navTarget = $(dom.navTarget).filter('[product-details-nav-target="' + navTargetName + '"]');
  var $navTargetRow = $(dom.navRow).filter('[product-details-nav-row="' + navTargetName + '"]');

  if (window.innerWidth >= breakpoint) {
    if (typeof event !== 'undefined') {
      deactivateTabs();
    }

    $navTab.addClass('is-active');
    $navTarget.addClass('is-active');
    $navTargetRow.addClass('is-active');
    $navTarget.css('display', 'block');
  } else {
    $navTab.toggleClass('is-active');
    $navTarget.slideToggle(300);
  }
};

var anchorToReviews = function anchorToReviews() {
  activateTab(undefined, 'reviews');
  (0, _LazyLoader.loadAll)(); // force lazyload to ensure page height / scroll depth is correct
  (0, _Scroll.smoothScroll)('reviews');
};

var initDetailBlocks = function initDetailBlocks() {
  activateTab(null, 'reviews');
  if (window.location.href.indexOf('#reviews') !== -1) {
    (0, _LazyLoader.loadAll)(); // force lazyload to ensure page height / scroll depth is correct
    $(window).on('load', function () {
      return (0, _Scroll.smoothScroll)('reviews');
    });
  }
};

var selectCallback = function selectCallback(variant, selector) {
  if (variant) {
    $(dom.addToCart).removeAttr('disabled');
    $(dom.addToCart).attr('data-variant-id', variant.id);
  } else {
    $(dom.addToCart).attr('disabled', true);
    $(dom.addToCart).attr('data-variant-id', undefined);
  }
};

var initShopifyOptions = function initShopifyOptions() {
  $(dom.shopifyProductForm + ':not(.is-loaded)').each(function () {
    var selector = $(this).attr('shopify-product-form');
    var productJSON = JSON.parse($(this).attr('data-product-json'));
    new Shopify.OptionSelectors(selector, {
      product: productJSON,
      onVariantSelected: selectCallback,
      enableHistoryState: true
    });
    $(this).addClass('is-loaded');
  });
};

var updateShopifyOptions = function updateShopifyOptions(event) {
  var $this = $(event.currentTarget);
  var value = $this.val();
  var optionIndex = parseInt($this.attr('data-option-index'));
  var $shopifySelect = $(dom.shopifyOptionSelector).filter('[data-option="option' + (optionIndex + 1) + '"]');
  $shopifySelect.val(value).trigger('change');
};

var updateActiveSubscriptionLabel = function updateActiveSubscriptionLabel(event) {
  var $this = $(event.currentTarget);
  var unit = $this.find('[subscription-unit]').text();
  $('[active-subscription-unit]').text(unit);
};

var autoSelectPurchaseType = function autoSelectPurchaseType() {
  var purchaseType = (0, _Helpers.getUrlParameterByName)('purchase_type');
  if (!purchaseType) return;
  var $option = $('[subscription-option] [value="' + purchaseType + '"]');
  var isDisabled = !$option.length || $option[0].disabled;
  if (!isDisabled) $option.trigger('click');
};

var bindUIActions = function bindUIActions() {
  $(dom.option).on('click', updateProductMeta);

  $(dom.qtyAdjustBtn).on('click', qtyBtnHandler);

  $(dom.qty).on('keyup', updateQty);

  $(dom.navTab).on('click', activateTab);

  $(dom.optionSelectTrigger).on('click', function () {
    (0, _Modal.show)('option-select');
    $(dom.optionSelectModalClose).trigger('focus');
  });

  $(dom.optionSelectModalClose).on('click', function () {
    return $(dom.optionSelectTrigger).trigger('focus');
  });

  $(dom.purchseTypeInput).on('change', changeVariantId);

  $(dom.reviewsAnchor).on('click', anchorToReviews);

  $(dom.swatch).on('click', updateShopifyOptions);

  $(dom.subscriptionFreqOption).on('click', updateActiveSubscriptionLabel);

  $(dom.subscriptionFreqSelect).on('change', function (event) {
    var $this = $(event.currentTarget);
    var value = $this.val();
    console.log('value', value);
    $(dom.subscriptionFreqOption).filter('[data-dropdown-value="' + value + '"]').trigger('click');
  });

  $(dom.productGalleryThumbnail).on('click', onThumbnailClick);
};

var init = exports.init = function init() {
  bindUIActions();
  initShopifyOptions();
  cacheProductData();
  initDetailBlocks();
  (0, _OOSAddToCart.init)();
  autoSelectPurchaseType();

  (0, _PropValues.init)();
  (0, _ProductReviews.initReviewContainers)();
  (0, _CrossSellCollection.init)();
  (0, _Venobox.bindVenobox)();

  // setup our accordions
  var ingredientsAccordionTiles = document.querySelectorAll('[data-ingredient-name]');
  (0, _Accordion.setupAccordionGroup)(ingredientsAccordionTiles);
  console.log('[BVA] Module Loaded: Product');
  initProductGallery();
};